import { render, staticRenderFns } from "./ClientBenefits.vue?vue&type=template&id=44dc4258&scoped=true"
import script from "./ClientBenefits.vue?vue&type=script&lang=ts"
export * from "./ClientBenefits.vue?vue&type=script&lang=ts"
import style0 from "./ClientBenefits.vue?vue&type=style&index=0&id=44dc4258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dc4258",
  null
  
)

export default component.exports